module.exports = __webpack_public_path__ + "img/about-pic.9576b690.jpg";